<h2 mat-dialog-title>Email in Use</h2>
<mat-dialog-content
    >This email address is already in use by another company's customer. Please use a different
    email address.</mat-dialog-content
>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
